import { defineMessages } from 'react-intl';

export default defineMessages({
    exposureError: {
        id: 'ml.quoteandbind.pup.ml-pup-watercraft-location-business-details.x marked with (!) need your attention',
        defaultMessage: '<strong>{item} marked with (!) need your attention.</strong> please click the edit link and fill out the required fields.',
    },
    animalExclusionError: {
        id: 'ml.common.directives.MLPUPLocationContantDirectiveCtrl.We will require an Animal Liability Exclusion to be included on your policy. Additional details will be included on your quote.',
        defaultMessage: 'We will require an Animal Liability Exclusion to be included on your policy. Additional details will be included on your quote.'
    },
    pageHeader: {
        id: 'ml.quoteandbind.pages.watercraft-location-business-details.PageHeader',
        defaultMessage: 'The properties below will be covered under your umbrella policy. Please make sure everything you want covered is listed and the information is accurate'
    },
    watercraftExposures: {
        id: 'ml.quoteandbind.pages.watercraft-location-business-details.WatercraftExposures',
        defaultMessage: 'Watercraft Exposures'
    },
    weWillReviewYourQuoteNext: {
        id: 'quoteandbind.pup.view.ml-pup-watercraft-location-business-details.We\'ll review your quote results next',
        defaultMessage: 'We\'ll {reviewYourQuote} next'
    },
    reviewYourQuote: {
        id: 'ml.quoteandbind.pa.additionalInformation.review your quote results',
        defaultMessage: 'review your quote results'
    },
    underlyingPolicyNotListed: {
        id: 'quoteandbind.pup.controllers.MLPUPWatercraftLocationBusinessDetailsCtrl.Policy is not listed',
        defaultMessage: 'Policy is not listed'
    },
    addAPolicy: {
        id: 'quoteandbind.pup.controllers.MLPUPWatercraftLocationBusinessDetailsCtrl.Add a Policy',
        defaultMessage: 'Add a Policy'
    },
    addPolicy: {
        id: 'quoteandbind.pup.controllers.MLPUPWatercraftLocationBusinessDetailsCtrl.Add Policy',
        defaultMessage: 'Add Policy'
    },
    cancel: {
        id: 'quoteandbind.pup.controllers.MLPUPWatercraftLocationBusinessDetailsCtrl.Cancel',
        defaultMessage: 'Cancel'
    },
    somethingWentWrong: {
        id: 'quoteandbind.pup.controllers.MLPUPWatercraftLocationBusinessDetailsCtrl.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    watercraftExposuresYearOfExpError: {
        id: 'quoteandbind.pup.controllers.MLPUPWatercraftLocationBusinessDetailsCtrl.Please fill the watercraft years of operating.',
        defaultMessage: 'Please fill the watercraft years of operating.'
    },

});
